import { useLazyQuery } from '@apollo/client';
import { Picker } from '@react-native-picker/picker';
import { useNavigation } from '@react-navigation/native';
import { FieldArray, Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import {
    ActivityIndicator,
    ScrollView,
    StyleSheet,
    View,
    Text,
} from 'react-native';
import { useDispatch } from 'react-redux';
import { AddSingleProductForm, Dropdown } from '../..';
import Dropdown2 from '../../common/dropdown2/dropdown2';
import { useGetAllBrands } from '../../../api/brands/useGetAllBrands';
import { useCreateMedia } from '../../../api/common/useCreateMedia';
import useCreateProduct from '../../../api/product/useCreateProduct';
import useEditProduct from '../../../api/product/useEditProduct';
import useGetAllProducts from '../../../api/product/useGetAllProducts';
import { PRODUCT_CATEGORIES, getFlatSubcategoriesForCategory } from '../../../utils/productCategories';
import { GET_PRODUCT } from '../../../graphql/product/queries';
import { setRefetchProduct } from '../../../redux/productsSlice';
import { TGetAllBrandsData } from '../../../types/brandTypes';
import {
    Media,
    TCreateProduct,
    TDropdownObject,
    TUseNavigation,
} from '../../../types/types';
import { getResponsiveStyle } from '../../../utils/getResponsiveStyle';
import Button from '../../common/button/Button';
import { HorizontalDivider } from '../../common/horizontal-divider';
import Input from '../../common/Input';
import Label from '../../common/label/Label';
import OptionButton from '../../common/option-button/OptionButton';
import Spacing from '../../common/spacing/spacing';
import Upload from '../../common/upload/upload';
import BooleanButton from './BooleanButton';
import {
    addSingleProductInitialValues,
    addSingleProductValidationSchema,
    emptyVariant,
    handleEditProducts,
    TStatus,
    emptyVariant as addVariantInitialValues,
    emptyValue,
} from './FormikConstants';
import { UploadedProductImage } from './UploadedProductImage';
import { Variant } from '../../../types/productTypes';
import { CategoryPill } from '../../common/filter-categories/CategoryPill';
import { TAddVariantFormValues } from './VariantFormConstants';
import useGetMedia from '../../../api/common/useGetMedia';
import { useSetAlert } from '../../../hooks/useSetAlerts';
import { palettes } from '../../../config';
import { useAppSelector } from '../../../redux/store';
import { extractFields, extractUniqueVariants, generateVariantCombinations, getVariantCombinationsForCards } from '../../../utils/generateVariantCombinations';
import ProductVariantCombinationCard from '../product-cards/ProductVariantCombinationCard';
import * as Yup from 'yup';

type Props = {
    productId?: string;
};
const AddSingleProductFormNew = (props: Props) => {
    const [productStatus, setProductStatus] = useState('ACTIVE');
    const [variantType, setVariantType] = useState<any[]>([]);
    const [variantValues, setVariantValues] = useState<any>({});
    const [variantValuesForCombination, setVariantValuesForCombination] = useState<any>({});
    const { INTEREST_TAGS } = useAppSelector(state => state.tag);
    const isEdit = props.productId ? true : false;
    const { setAlert } = useSetAlert();
    const [currentVariant, setCurrentVariant] = useState(0);
    const [media, setMedia] = useState<Media[]>([]);
    const {
        _createMedia,
        loading: loading_uploadMedia,
        data: mediaData,
    } = useCreateMedia({});

    const [getSingleProduct, { data: product, loading: productLoading }] =
        useLazyQuery(GET_PRODUCT, {
            onCompleted: data => {
                setProductStatus(data?.getProduct?.data?.publishedStatus);
            },
        });
    useEffect(() => {
        if (props.productId)
            getSingleProduct({ variables: { _id: props.productId } });
    }, []);

    const productData = product?.getProduct?.data;

    const dispatch = useDispatch();

    const {
        executeProductMutation,
        data,
        loading: productCreateLoading,
    } = useCreateProduct();
    const {
        executeProductEditMutation,
        data: productEdit,
        loading: productEditLoading,
    } = useEditProduct();

    const { loggedInUserDetails } = useAppSelector(state => ({
        loggedInUserDetails: state.auth.loggedInUserDetails,
    }));

    const navigation = useNavigation<TUseNavigation>();
    const { getAllBrands, data: brandApiData } = useGetAllBrands();
    useEffect(() => {
        const media = mediaData?.createMedia?.data;

        if (media) {
            setMedia(prev => [...prev, media]);
        }
    }, [mediaData]);

    useEffect(() => {
        getAllBrands();
    }, []);

    const brandTestData = [
        {
            _id: '',
            companyName: 'Select Brand'
        }
    ]

    const brandData = () => {
        if (loggedInUserDetails?.affiliatedBrand) {
            return brandTestData?.concat(brandApiData?.filter((data: any) => data?._id === loggedInUserDetails?.affiliatedBrand))
        } else {
            return brandApiData
        }
    }

    const variantTypes = [
        {
            _id: '',
            variantName: 'Select Variant'
        },
        {
            _id: 'Size',
            variantName: 'Size'
        },
        {
            _id: 'Color',
            variantName: 'Color'
        },
        {
            _id: 'Material',
            variantName: 'Material'
        },
        {
            _id: 'Type',
            variantName: 'Type'
        },
        {
            _id: 'Volume',
            variantName: 'Volume'
        },
        {
            _id: 'Weight',
            variantName: 'Weight'
        },
        {
            _id: 'Dimension',
            variantName: 'Dimension'
        },
    ]
    //TODO for deleting variants
    // const handleRemove=()=>{

    // }

    useEffect(() => {
        if (productEdit) {
            navigation.navigate('Products');
            // dispatch(setRefetchProduct(true));
        }
    }, [productEdit]);

    useEffect(() => {
        if (productData?._id) {
            const [firstVariator, secondVariator] = productData?.variants?.[0]?.option?.variatorValues
            if (firstVariator) {
                setVariantValues({ ...firstVariator?.variatorValues, ...secondVariator?.variatorValues })
                setVariantValuesForCombination(productData?.variants?.[0]?.option?.variantValuesForCombination?.[0])
                const firstVariantType = Object.values(productData?.variants?.[0]?.option?.variatorValues?.[0]?.variatorValues || {})?.map((data: any, index: number) => {
                    return {
                        type: firstVariator?.variator,
                        indexPlace: index
                    }
                })
                const secondVariantType = Object.values(productData?.variants?.[0]?.option?.variatorValues?.[1]?.variatorValues || {})?.map((data: any, index: number) => {
                    return {
                        type: secondVariator?.variator,
                        indexPlace: index
                    }
                })

                setVariantType([...firstVariantType, ...secondVariantType])
            }
        }
    }, [productData])
    const variantCombinationArray = Object.values(variantValuesForCombination || {})

    const getFromForVariant = (variant: string) => {
        if (isEdit && variantCombinationArray?.length) {
            return variantCombinationArray?.filter((data: any) => variant === data?.variantType)
        } else {
            return variantType?.filter(data => variant === data?.type)
        }

        // return variantType?.filter(data => variant === data?.type)
        // return Object.values(variantValuesForCombination)?.filter((data: any) => variant === data?.variantType)
    }


    const dynamicSetInputValues = (field: string, text: string, variantType: string) => {
        setVariantValuesForCombination({
            ...variantValuesForCombination,
            [field]: {
                text,
                variantType,
            }
        })
        // if (isEdit && variantCombinationArray?.length) {
        //     setVariantValuesForCombination({
        //         ...variantValuesForCombination,
        //         [field]: {
        //             text,
        //             variantType,
        //         }
        //     })
        // } else {
        //     setVariantValues({
        //         ...variantValues,
        //         [field]: {
        //             text,
        //             variantType,
        //             // quantity: variantValues[field]?.quantity,
        //             // associatedVariant: variantValues[field]?.associatedVariant,
        //             // price: variantValues[field]?.price,
        //             // comparePrice: variantValues[field]?.comparePrice,
        //         },
        //     })
        // }

        // setVariantValuesForCombination({
        //     ...variantValuesForCombination,
        //     [field]: {
        //         text,
        //         variantType,
        //         // quantity: variantValuesForCombination[field]?.quantity,
        //         // associatedVariant: variantValuesForCombination[field]?.associatedVariant,
        //         // price: variantValuesForCombination[field]?.price,
        //         // comparePrice: variantValuesForCombination[field]?.comparePrice,
        //     }
        // })
    }

    // console.log({ variantValuesForCombination });



    const dynamicGroupQuantityWithValue = (field: string, quantity: string) => {
        // console.log({ field, quantity, variantValues });
        setVariantValues({
            ...variantValues,
            [field]: {
                text: variantValues[field]?.text,
                quantity: +quantity,
                associatedVariant: variantValues[field]?.associatedVariant,
                price: variantValues[field]?.price,
                comparePrice: variantValues[field]?.comparePrice,
                variantKey: variantValues[field]?.variantKey,
                variantType: variantValues[field]?.variantType,
                image: variantValues[field]?.image,
            },
        })
    }

    const dynamicGroupPriceWithValue = (field: string, price: string) => {
        setVariantValues({
            ...variantValues,
            [field]: {
                text: variantValues[field]?.text,
                quantity: variantValues[field]?.quantity,
                associatedVariant: variantValues[field]?.associatedVariant,
                price: +price,
                comparePrice: variantValues[field]?.comparePrice,
                variantKey: variantValues[field]?.variantKey,
                variantType: variantValues[field]?.variantType,
                image: variantValues[field]?.image,
            },
        })
    }

    const dynamicGroupComparePriceWithValue = (field: string, price: string) => {
        setVariantValues({
            ...variantValues,
            [field]: {
                text: variantValues[field]?.text,
                quantity: variantValues[field]?.quantity,
                associatedVariant: variantValues[field]?.associatedVariant,
                price: variantValues[field]?.price,
                comparePrice: price,
            },
        })
    }

    const dynamicGroupVariantWithAssociate = (field: string, text: string) => {
        setVariantValues({
            ...variantValues,
            [field]: {
                text: variantValues[field]?.text,
                quantity: variantValues[field]?.quantity,
                associatedVariant: text,
                price: variantValues[field]?.price,
                comparePrice: variantValues[field]?.comparePrice,
            },
        })
    }


    const getInputValue = (variator: string, field: string) => {
        // console.log({ variantValues, variator, field });
        const variantCombinationArray = Object.values(variantValuesForCombination || {})
        if (variantCombinationArray?.length) {
            return variantValuesForCombination?.[variator]?.[field]
        } else {
            return variantValues?.[variator]?.[field]
        }
        // return variantValuesForCombination[variator]?.[field]
    }

    const getVariatorSecondVariantValues = (variant: string) => {
        const secondVariantValues = Object.values(extractFields(variantValues, variant) || {})?.map((data: any) => {
            return {
                key: data?.text,
                value: data?.text,
            }
        })
        return [{ key: "Select", value: null }, ...secondVariantValues]
    }

    // console.log({ variantValuesSelect: extractFields(variantValues, 'Size'), variantValues: getFromForVariant('Size'), variantType });

    // Add a function to handle the generation of variant combinations
    const handleGenerateVariantCombinations = () => {
        // Only proceed if we have variants defined
        console.log({ variantValuesForCombination });
        if (variantType.length < 2 || Object.keys(variantValuesForCombination || {}).length < 2) {
            setAlert('Not enough variants defined. Add at least one of each type.', 'warning');
            return;
        }

        // Determine the primary combinator (using the first variant type)
        const primaryCombinator = variantType[0].type;

        // console.log({ variantValuesForCombination, primaryCombinator });

        // Generate the combinations
        const expandedVariants = generateVariantCombinations(
            variantValuesForCombination,
            primaryCombinator
        );

        // Update the variant values state
        setVariantValues(expandedVariants);

        // Show success message
        setAlert('Variant combinations generated successfully!', 'normal');
    };

    // Handle quantity change for variant combinations
    const handleQuantityChange = (variantKey: string, quantity: number) => {
        dynamicGroupQuantityWithValue(variantKey, quantity.toString());
    };

    // Handle price change for variant combinations
    const handlePriceChange = (variantKey: string, price: number) => {
        dynamicGroupPriceWithValue(variantKey, price.toString());
    };

    // Handle image upload for variant combinations
    const handleImageUpload = (variantKey: string, imageUrl: string) => {
        setVariantValues((prev: any) => ({
            ...prev,
            [variantKey]: {
                ...prev[variantKey],
                image: imageUrl
            }
        }));
    };

    // Add state for category and subcategory
    const [selectedCategory, setSelectedCategory] = useState('');
    const [availableSubcategories, setAvailableSubcategories] = useState<Array<{ label: string; value: string }>>([]);

    // Update subcategories when category changes
    useEffect(() => {
        if (selectedCategory || productData?.category?.[0]) {
            const subcategories = getFlatSubcategoriesForCategory(selectedCategory || productData?.category?.[0]);
            setAvailableSubcategories(subcategories);
        } else {
            setAvailableSubcategories([]);
        }
    }, [selectedCategory, productData]);

    return (
        <Formik
            enableReinitialize
            initialValues={
                props.productId
                    ? handleEditProducts(productData)
                    : {
                        ...addSingleProductInitialValues,
                        category: productData?.category || '',
                        subcategory: productData?.subcategory || '',
                    }
            }
            validationSchema={addSingleProductValidationSchema}
            onSubmit={async (values, { resetForm }) => {
                const data = {
                    name: values.productName,
                    shortDescription: values.shortDescription,
                    description: values.description,
                    publishedStatus: productStatus,
                    category: values.category ? [values.category] : [],
                    subCategory: values.subcategory,
                    brand: values.brand,
                    variants: [{
                        // variator: values?.variants[0].variantType,
                        value: values.value,
                        GTIN: values?.GTIN,
                        image: values?.image?._id || values?.variants?.[0]?.image?._id,
                        _id:
                            values?._id && values?._id.length
                                ? values?._id
                                : undefined,
                        vat: +values?.vat,
                        weight: Number(values?.weight),
                        weightUnit: values.weightUnit,
                        option: {
                            values: [
                                {
                                    price: +extractFields(variantValues, values?.variants[0]?.variantType)?.[`${values?.variants[0]?.variantType}1`]?.price,
                                    name: values?.variants[0]?.variantType,
                                }
                            ],
                            variantValuesForCombination: extractUniqueVariants(variantValues),
                            variatorValues: values?.variants?.map((data) => {
                                return {
                                    variator: data?.variantType,
                                    variatorValues: extractFields(variantValues, data?.variantType)
                                }
                            }),

                            inventory: {
                                isAvailable: true,
                                isTracked: true,
                                quantity: Number(
                                    Object.values(extractFields(variantValues, values?.variants[0]?.variantType))?.map((data: any) => data?.quantity)?.reduce((a: any, b: any) => +a + +b, 0)
                                ),
                            },
                        },
                    }
                    ]
                    // variants: values?.variants?.map(variant => {
                    // 	return {
                    // 		variator: variant.variantType,
                    // 		value: variant.value,
                    // 		GTIN: variant?.GTIN,
                    // 		image: variant?.image?._id?.length
                    // 			? variant?.image?._id
                    // 			: undefined,
                    // 		_id:
                    // 			variant?._id && variant?._id.length
                    // 				? variant?._id
                    // 				: undefined,
                    // 		vat: +variant?.vat,
                    // 		weight: Number(variant?.weight),
                    // 		weightUnit: variant.weightUnit,
                    // 		option: {
                    // 			name: variant?.options?.name,
                    // 			values: variant?.options?.values?.map(
                    // 				(item, index) => {
                    // 					return {
                    // 						price: +item.price,
                    // 						compareAtPrice:
                    // 							Number(item.compareAtPrice) ??
                    // 							undefined,
                    // 						name: item.name,
                    // 					};
                    // 				}
                    // 			),

                    // 			inventory: {
                    // 				isAvailable:
                    // 					variant?.options?.inventory.isAvailable,
                    // 				isTracked:
                    // 					variant?.options?.inventory?.isTracked,
                    // 				quantity: Number(
                    // 					variant?.options?.inventory.quantity
                    // 				),
                    // 			},
                    // 		},
                    // 	};
                    // }),
                };

                console.log(data, values, 'form values');
                if (props.productId) {
                    executeProductEditMutation(
                        props.productId as string,
                        data as unknown as TCreateProduct
                    );
                    return;
                }
                const response = await executeProductMutation(
                    data as unknown as TCreateProduct
                );
                if (response.data?.createProduct?.success) {
                    resetForm();
                    setMedia([]);
                    setVariantValues({})
                    setVariantType([])
                    setCurrentVariant(0)
                    navigation.navigate('Products');
                }
            }}
        >
            {({
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit,
                dirty,
                isValid,
                touched,
                errors,
                values,
            }) => {

                return (
                    <>
                        <Spacing
                            orientation="column"
                            spacing={20}
                            containerStyles={{
                                marginBottom: getResponsiveStyle(80),
                            }}
                        >
                            <Input
                                label="Product Name*"
                                onChangeText={handleChange('productName')}
                                onBlur={handleBlur('productName')}
                                value={values.productName}
                                error={
                                    touched.productName && errors.productName
                                        ? errors.productName
                                        : ''
                                }
                            />

                            <Input
                                multiline
                                label={'Short Description*'}
                                style={[styles.shortDescription]}
                                onChangeText={handleChange('shortDescription')}
                                onBlur={handleBlur('shortDescription')}
                                value={values.shortDescription}
                                error={
                                    touched.shortDescription &&
                                        errors.shortDescription
                                        ? errors.shortDescription
                                        : ''
                                }
                            />
                            <Input
                                multiline
                                label={'Description*'}
                                style={[styles.description]}
                                value={values.description}
                                onChangeText={handleChange('description')}
                                onBlur={handleBlur('description')}
                                error={
                                    touched.description && errors.description
                                        ? errors.description
                                        : ''
                                }
                            />

                            <Dropdown
                                labelProps={{
                                    label: 'Brand:',
                                }}
                                pickerProps={{
                                    selectedValue: values.brand,
                                    onValueChange: value => {
                                        setFieldValue('brand', value);
                                    },
                                    children: (
                                        <>
                                            {brandData()?.map((brand: any) => (
                                                <Picker.Item
                                                    label={brand?.companyName}
                                                    value={brand?._id}
                                                />
                                            ))}
                                        </>
                                    ),
                                }}
                            />
                            <HorizontalDivider paddingY={getResponsiveStyle(24)} />

                            <Dropdown
                                labelProps={{
                                    label: 'Product Categorie*',
                                }}
                                pickerProps={{
                                    selectedValue: values.category,
                                    onValueChange: value => {
                                        setFieldValue('category', value);
                                        setSelectedCategory(value?.toString())
                                    },
                                    children: (
                                        <>
                                            {PRODUCT_CATEGORIES?.map((category: any) => (
                                                <Picker.Item
                                                    label={category?.label}
                                                    value={category?.value}
                                                />
                                            ))}
                                        </>
                                    ),
                                }}
                            />
                            <>
                                {values?.category?.length > 0 && (
                                    <Dropdown
                                        labelProps={{
                                            label: 'Sub Categories*',
                                        }}
                                        pickerProps={{
                                            selectedValue: values?.subcategory,
                                            onValueChange: value => {
                                                setFieldValue('subcategory', value);
                                            },
                                            children: (
                                                <>
                                                    {[{ label: 'Select Subcategory', value: '' }, ...availableSubcategories]?.map((subcategory: any) => (
                                                        <Picker.Item
                                                            label={subcategory?.label}
                                                            value={subcategory?.value}
                                                        />
                                                    ))}
                                                </>
                                            ),
                                        }}
                                    />
                                )}
                            </>
                            {/* <Dropdown2
                                isSearchable
                                key={'dropdown'}
                                options={PRODUCT_CATEGORIES}
                                inputProps={{
                                    placeholder: 'Product Categories hint',
                                }}
                                labelProps={{
                                    label: 'Product Categories*',
                                }}
                                values={PRODUCT_CATEGORIES.filter(item =>
                                    values.category?.includes(item.value)
                                )}
                                onChangeValue={(value: TDropdownObject) => {
                                    setFieldValue('category', [
                                        ...values?.category,
                                        value?.value,
                                    ]);
                                }}
                                onPressCrossOnBadge={(value: string) => {
                                    const filteredProductCategory =
                                        values?.category?.filter(
                                            item => item !== value
                                        );

                                    setFieldValue(
                                        'category',
                                        filteredProductCategory
                                    );
                                }}
                            /> */}
                            <Spacing spacing={14} withEqualWidth>
                                <OptionButton
                                    onClick={() => {
                                        setProductStatus(TStatus.DRAFT);
                                        //setFieldValue('status', TStatus.DRAFT);
                                    }}
                                    value={TStatus.DRAFT}
                                    active={productStatus === 'DRAFT'}
                                    title={'Draft'}
                                    titleStyles={{
                                        textAlign: 'center',
                                    }}
                                />
                                <OptionButton
                                    onClick={() => {
                                        setProductStatus(TStatus.ACITVE);
                                        //setFieldValue('status', TStatus.ACITVE);
                                    }}
                                    value={TStatus.ACITVE}
                                    active={productStatus === 'ACTIVE'}
                                    title={'Active'}
                                    titleStyles={{
                                        textAlign: 'center',
                                    }}
                                />
                            </Spacing>

                            <HorizontalDivider paddingY={getResponsiveStyle(24)} />
                            <View
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                <ScrollView
                                    horizontal
                                    showsHorizontalScrollIndicator={false}
                                    style={{ marginRight: 20 }}
                                >
                                    {values?.variants?.length ? (
                                        values?.variants?.map((item, index) => (
                                            <CategoryPill
                                                value={item?.value}
                                                selected={index === currentVariant}
                                                text={`Variant ${values?.variants?.[index]
                                                    ?.variantType?.length
                                                    ? values?.variants?.[index]
                                                        ?.variantType +
                                                    ' '
                                                    : index + 1
                                                    }`}
                                                onClick={() => {
                                                    setCurrentVariant(index);
                                                }}
                                            />
                                        ))
                                    ) : (
                                        <Text style={{ color: 'red' }}>
                                            At least one variant is required*
                                        </Text>
                                    )}
                                </ScrollView>
                                {values?.variants?.length === 2 ? <Button
                                    title="Generate Variant Combinations"
                                    onPress={handleGenerateVariantCombinations}
                                /> : <Button
                                    title="Add Variant"
                                    onPress={() => {
                                        setFieldValue('variants', [
                                            ...values.variants,
                                            emptyVariant,
                                        ]);
                                        setCurrentVariant(values.variants.length);
                                    }}
                                />}
                            </View>
                            <>
                                {values?.variants?.map((item, index) => (
                                    <FieldArray
                                        key={index}
                                        name="variant"
                                        render={_arrayHelpers =>
                                            index === currentVariant && (
                                                <>
                                                    <>
                                                        <Spacing
                                                            key={index}
                                                            orientation="column"
                                                            spacing={20}
                                                        >
                                                            <Dropdown
                                                                labelProps={{
                                                                    label: 'Variant Type*',
                                                                }}
                                                                pickerProps={{
                                                                    selectedValue: item.variantType,
                                                                    onValueChange: value => {
                                                                        setFieldValue(
                                                                            'variants.' +
                                                                            [
                                                                                index,
                                                                            ] +
                                                                            '.variantType',
                                                                            value
                                                                        );
                                                                    },
                                                                    children: (
                                                                        <>
                                                                            {variantTypes?.map((brand: any) => (
                                                                                <Picker.Item
                                                                                    label={brand?.variantName}
                                                                                    value={brand?._id}
                                                                                />
                                                                            ))}
                                                                        </>
                                                                    ),
                                                                }}
                                                            />
                                                            <ScrollView
                                                                horizontal
                                                                showsHorizontalScrollIndicator={false}
                                                            >
                                                                <View>
                                                                    <View style={{ flexDirection: "row" }}>
                                                                        {getFromForVariant(item?.variantType)?.map((_, index) => <Input
                                                                            containerStyles={{ width: 130 }}
                                                                            label={`${item.variantType} ${index + 1}`}
                                                                            onChangeText={(text) => dynamicSetInputValues(`${item.variantType}${index + 1}`, text, item?.variantType)}
                                                                            // onBlur={handleBlur('productName')}
                                                                            value={getInputValue(`${item.variantType}${index + 1}`, 'text')}
                                                                        />)}
                                                                    </View>
                                                                    <Button
                                                                        title="Add Variant Type"
                                                                        onPress={() => {
                                                                            if (item.variantType) setVariantType([...variantType, { type: item.variantType, indexPlace: variantType.length }])
                                                                        }}
                                                                    />

                                                                    {/* <View style={{ marginTop: 16, padding: 12, backgroundColor: palettes.grey[6], borderRadius: 8 }}>
                                                                        <Text style={{ marginBottom: 8, fontWeight: '500', color: palettes.dark[0] }}>
                                                                            Variant Combination Generator
                                                                        </Text>
                                                                        <Text style={{ marginBottom: 12, color: palettes.grey[1], fontSize: 12 }}>
                                                                            This will generate all possible combinations of your variants using the first variant type as the primary combinator.
                                                                        </Text>
                                                                        <Button
                                                                            title="Generate All Combinations"
                                                                            variant="primary"
                                                                            onPress={handleGenerateVariantCombinations}
                                                                            outerContainerProps={{ style: { marginTop: 4 } }}
                                                                        />
                                                                    </View> */}
                                                                </View>
                                                            </ScrollView>

                                                            <>
                                                                {(() => {
                                                                    // Get the variant combinations
                                                                    const variantCombinations = getVariantCombinationsForCards(values.variants[0]?.variantType, variantValues);

                                                                    // Only show when there are actual combinations available
                                                                    return variantCombinations && variantCombinations.length > 0 && (
                                                                        <View style={{ marginTop: 24, marginBottom: 24 }}>
                                                                            <Text style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 16 }}>
                                                                                Variant Combinations
                                                                            </Text>

                                                                            {variantCombinations.map((variant, index) => (
                                                                                <ProductVariantCombinationCard
                                                                                    key={`${index}`}
                                                                                    secondaryVariantType={values.variants[1]?.variantType}
                                                                                    variantKey={variant.variantKey as string}
                                                                                    associatedVariant={variant.associatedVariant as string}
                                                                                    text={variant.text}
                                                                                    variantType={variant.variantType}
                                                                                    quantity={variant.quantity as number}
                                                                                    price={variant.price}
                                                                                    compareAtPrice={variant.compareAtPrice}
                                                                                    image={variant.image}
                                                                                    onDelete={(variantKey: string) => {
                                                                                        // Simply remove this variant from the state
                                                                                        const newVariantValues = { ...variantValues };
                                                                                        delete newVariantValues[variantKey];
                                                                                        setVariantValues(newVariantValues);
                                                                                    }}
                                                                                    onQuantityChange={handleQuantityChange}
                                                                                    onPriceChange={handlePriceChange}
                                                                                    onImageUpload={handleImageUpload}
                                                                                />
                                                                            ))}
                                                                        </View>
                                                                    );
                                                                })()}
                                                            </>
                                                            {/* <Input
																label="Variant Type*"
																onChangeText={text => {
																	setFieldValue(
																		'variants.' +
																		[
																			index,
																		] +
																		'.variantType',
																		text
																	);
																}}
																onBlur={handleBlur(
																	'variants.' +
																	[index] +
																	'.variantType'
																)}
																value={
																	item.variantType
																}
																error={
																	touched.variants &&
																		touched
																			.variants[
																	index
																] &&
																		errors.variants
																		? errors
																			.variants[
																		index
																	]
																			?.variantType
																		: ''
																}
															/> */}
                                                            {/* <Input
																label="Variant Value *"
																onChangeText={text => {
																	setFieldValue(
																		'variants.' +
																		[
																			index,
																		] +
																		'.value',
																		text
																	);
																}}
																onBlur={handleBlur(
																	'variants.' +
																	[index] +
																	'.value'
																)}
																value={item.value}
																error={
																	touched.variants &&
																		touched
																			.variants[
																	index
																] &&
																		errors.variants
																		? errors
																			.variants[
																		index
																	]?.value
																		: ''
																}
															/> */}
                                                        </Spacing>
                                                    </>
                                                </>
                                            )
                                        }
                                    />
                                ))}
                            </>
                            <>
                                <Input
                                    label="Product ID/GTIN *"
                                    onChangeText={text => {
                                        setFieldValue('GTIN', text);
                                    }}
                                    onBlur={handleBlur("GTIN")}
                                    value={values.GTIN}
                                    error={
                                        touched?.GTIN && errors?.GTIN ? errors?.GTIN : ''
                                    }
                                />
                                <View>
                                    <Upload
                                        label="Product Image*"
                                        hint="Drop files to upload"
                                        onDrop={e =>
                                            _createMedia(
                                                {
                                                    variables:
                                                    {
                                                        file: e[0] as File,
                                                        category:
                                                            'PRODUCT',
                                                        alt: 'media-files',
                                                    },
                                                    onCompleted:
                                                        data => {
                                                            setAlert(
                                                                'Upload Successful',
                                                                'normal'
                                                            );
                                                            console.log(
                                                                data
                                                                    .createMedia
                                                                    .data
                                                            );
                                                            setFieldValue(
                                                                'image',
                                                                {
                                                                    _id: data
                                                                        ?.createMedia
                                                                        ?.data
                                                                        ?._id,
                                                                    src: data
                                                                        ?.createMedia
                                                                        ?.data
                                                                        ?.src,
                                                                }
                                                            );
                                                        },
                                                }
                                            )
                                        }
                                        dropzoneStyles={{
                                            height: getResponsiveStyle(
                                                240,
                                                'dimensions'
                                            ),
                                        }}
                                        containerStyles={{
                                            marginBottom:
                                                getResponsiveStyle(
                                                    24
                                                ),
                                        }}
                                    />
                                    {loading_uploadMedia ? (
                                        <ActivityIndicator
                                            size="small"
                                            style={{
                                                margin: 20,
                                            }}
                                        />
                                    ) : (
                                        (values?.image?._id || !!values
                                            .variants?.[
                                            0
                                        ]?.image?._id
                                            ?.length) && (
                                            <Spacing>
                                                <UploadedProductImage
                                                    image={
                                                        values?.image?.src || values
                                                            .variants[0]
                                                            .image
                                                            .src
                                                    }
                                                />
                                                <></>
                                            </Spacing>
                                        )
                                    )}
                                </View>
                                <Spacing
                                    spacing={8}
                                    withEqualWidth
                                >
                                    <Input
                                        label="VAT (%)*"
                                        value={values.vat}
                                        onChangeText={text => {
                                            setFieldValue(
                                                'vat',
                                                text
                                            );
                                        }}
                                        onBlur={handleBlur(
                                            'vat'
                                        )}
                                        error={
                                            touched?.vat && errors?.vat ? errors?.vat : ''
                                        }
                                    />
                                    <View></View>
                                </Spacing>

                                {/* <Input
									label="Option Name"
								// onChangeText={text => {
								// 	setFieldValue(
								// 		'variants.' +
								// 		[
								// 			index,
								// 		] +
								// 		'.options.name',
								// 		text
								// 	);
								// }}
								// onBlur={handleBlur(
								// 	'variants.' +
								// 	[index] +
								// 	'.options.name'
								// )}
								// value={
								// 	values.variants[
								// 		index
								// 	].options
								// 		.name ?? ''
								// }
								// error={
								// 	touched.variants &&
								// 		touched
								// 			.variants[
								// 		index
								// 		] &&
								// 		errors.variants
								// 		? errors
								// 			.variants[
								// 			index
								// 		]?.options
								// 			?.name
								// 		: ''
								// }
								/> */}
                                {/* <Text
									style={{
										color: 'red',
										paddingVertical:
											'20px',
									}}
								>
									At least one Option is
									required*
								</Text>
								{item?.options?.values?.map(
									(item1, index1) => (
										<Spacing
											key={
												index1 +
												'nested'
											}
											spacing={8}
											withEqualWidth
										>
											<Input
												label="Option Value"
												onChangeText={text => {
													setFieldValue(
														'variants.' +
														[
															index,
														] +
														'.options.values.' +
														[
															index1,
														] +
														'.name',
														text
													);
												}}
												onBlur={handleBlur(
													'variants.' +
													[
														index,
													] +
													'.options.values.' +
													[
														index1,
													] +
													'.name'
												)}
												value={
													item1?.name
												}
												error={
													touched.variants &&
														touched
															.variants[
														index
													] &&
														errors.variants
														? errors
															.variants[
														index
													]
															?.options
															?.values[
														index1
													]
															?.name
														: ''
												}
											/>

											<Input
												label="Listed Price"
												// onChangeText={text => {
												// 	setFieldValue(
												// 		'variants.' +
												// 		[
												// 			index,
												// 		] +
												// 		'.options.values.' +
												// 		[
												// 			index1,
												// 		] +
												// 		'.price',
												// 		text
												// 	);
												// }}
												// onBlur={handleBlur(
												// 	'variants.' +
												// 	[
												// 		index,
												// 	] +
												// 	'.options.values.' +
												// 	[
												// 		index1,
												// 	] +
												// 	'.price'
												// )}
												// value={
												// 	(values.variants &&
												// 		values
												// 			.variants[
												// 		index
												// 		] &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options
												// 			.values &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options
												// 			.values[
												// 		index1
												// 		] &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options
												// 			.values[
												// 			index1
												// 		]
												// 			.price) ||
												// 	''
												// }
												// error={
												// 	touched.variants &&
												// 		touched
												// 			.variants[
												// 		index
												// 		] &&
												// 		errors.variants
												// 		? errors
												// 			.variants[
												// 			index
												// 		]
												// 			?.options
												// 			?.values[
												// 			index1
												// 		]
												// 			?.price
												// 		: ''
												// }
											/>

											<Input
												label="Compare Price"
												// onChangeText={text => {
												// 	setFieldValue(
												// 		'variants.' +
												// 		[
												// 			index,
												// 		] +
												// 		'.options.values.' +
												// 		[
												// 			index1,
												// 		] +
												// 		'.compareAtPrice',
												// 		text
												// 	);
												// }}
												// onBlur={handleBlur(
												// 	'variants.' +
												// 	[
												// 		index,
												// 	] +
												// 	'.options.values.' +
												// 	[
												// 		index1,
												// 	] +
												// 	'.compareAtPrice'
												// )}
												// value={
												// 	(values.variants &&
												// 		values
												// 			.variants[
												// 		index
												// 		] &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options
												// 			.values &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options
												// 			.values[
												// 		index1
												// 		] &&
												// 		values
												// 			.variants[
												// 			index
												// 		]
												// 			.options
												// 			.values[
												// 			index1
												// 		]
												// 			.compareAtPrice) ||
												// 	''
												// }
												// error={
												// 	touched.variants &&
												// 		touched
												// 			.variants[
												// 		index
												// 		] &&
												// 		errors.variants
												// 		? errors
												// 			.variants[
												// 			index
												// 		]
												// 			?.options
												// 			?.values[
												// 			index1
												// 		]
												// 			?.compareAtPrice
												// 		: ''
												// }
											/>
										</Spacing>
									)
								)} */}
                                {/* <Button
									title="Add Option Value"
								// onPress={() => {
								// 	setFieldValue(
								// 		'variants.' +
								// 		[index] +
								// 		'.options.values',
								// 		[
								// 			...values
								// 				.variants[
								// 				index
								// 			].options
								// 				.values,
								// 			emptyValue,
								// 		]
								// 	);
								// }}
								/> */}
                                {/* <HorizontalDivider
									paddingY={getResponsiveStyle(
										24
									)}
								/>
								<View
									style={
										styles.removeContainer
									}
								>
									<Input
										label="Stock quantity*"
										onChangeText={text => {
											setFieldValue(
												'variants.' +
												'.options.inventory.quantity',
												text
											);
										}}
									// onBlur={handleBlur(
									// 	'variants.' +
									// 	[index] +
									// 	'.options.inventory.quantity'
									// )}
									// value={
									// 	item.options
									// 		.inventory
									// 		.quantity
									// }
									// error={
									// 	touched?.variants &&
									// 		touched
									// 			.variants[
									// 		index
									// 		] &&
									// 		errors?.variants &&
									// 		errors.variants[
									// 		index
									// 		] &&
									// 		errors
									// 			?.variants[
									// 			index
									// 		]?.options &&
									// 		errors.variants[
									// 			index
									// 		]?.options
									// 			.errors
									// 			?.variants[
									// 			index
									// 		]?.options
									// 			.inventory
									// 		? errors
									// 			.variants[
									// 			index
									// 		]?.options
									// 			.errors
									// 			?.variants[
									// 			index
									// 		]?.options
									// 			.inventory
									// 			?.quantity
									// 		: ''
									// }
									/>
								</View> */}
                                <View
                                    style={
                                        styles.removeContainer
                                    }
                                >
                                    <Input
                                        label="Weight (kgs):"
                                        // onChangeText={text => {
                                        // 	setFieldValue(
                                        // 		'variants.' +
                                        // 		[
                                        // 			index,
                                        // 		] +
                                        // 		'.weight',
                                        // 		text
                                        // 	);
                                        // }}
                                        // onBlur={handleBlur(
                                        // 	'variants.' +
                                        // 	[index] +
                                        // 	'.weight'
                                        // )}
                                        value={
                                            values.weight ??
                                            ''
                                        }
                                        onChangeText={text => {
                                            setFieldValue(
                                                'weight',
                                                text
                                            );
                                        }}
                                        onBlur={handleBlur(
                                            'weight'
                                        )}
                                        error={
                                            touched?.weight && errors?.weight ? errors?.weight : ''
                                        }
                                    />
                                </View>
                            </>
                            <></>
                        </Spacing>
                        <Button
                            title={`${props.productId ? 'Update' : 'Save'}`}
                            variant={isValid ? 'primary' : 'disabled'}
                            size="lg"
                            onPress={handleSubmit}
                            loading={productCreateLoading || productEditLoading}
                        />
                    </>
                );
            }}
        </Formik>
    );
};

export default AddSingleProductFormNew;

/* 
How to use the ProductVariantCombinationCard component:

The ProductVariantCombinationCard component has been updated to display primary variant types
outside the ScrollView. Here's an example of how to use it:

1. First, you need to get the primary and secondary variants properly grouped
2. For each combination, render the card with these props:

<ProductVariantCombinationCard
    image="https://via.placeholder.com/100" // Product image URL
    productName="Product Name" // Product name
    variantCombination={[
        { name: "Color", value: "Red" }, // Primary variant
        { name: "Size", value: "Medium" } // Secondary variant
    ]}
    quantity={5} // Current quantity
    sku="PRD-Red-Medium" // Generated SKU
    variantKey="Size2" // This is the key in your variantValues object
    primaryVariantType="Color" // The primary variant type name
    primaryVariantValue="Red" // The primary variant value
    onDelete={() => {
        // Remove this variant from the state
    }}
    onQuantityChange={(variantKey, newQuantity) => {
        // Update quantity in parent state
        // e.g. dynamicGroupQuantityWithValue(variantKey, newQuantity.toString())
    }}
/>

The component will display the primary variant in a header section outside 
the card and the secondary variant inside the card along with the product details.
When the quantity is changed, it will call onQuantityChange with the variantKey
and the new quantity value, allowing the parent component to update its state.
*/

const styles = StyleSheet.create({
    description: {
        paddingVertical: getResponsiveStyle(20),
        height: getResponsiveStyle(160, 'dimensions'),
    },
    removeContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    shortDescription: {
        paddingVertical: getResponsiveStyle(20),
        height: getResponsiveStyle(90, 'dimensions'),
    },
});
